import { Text } from '@eo-locale/react';
import { FC, useMemo } from 'react';
import {
  InnerPageSection,
  InnerPageTitle,
  MembershipWidget,
  Money,
  Table,
} from '../components';
import { useUserContributions } from '../hooks';

export const ContributionsPage: FC = () => {
  const { actives = [], history = [] } = useUserContributions();

  // (opcjonalnie) prosty deduplikator po collection_id
  const activeRows = useMemo(() => {
    const map = new Map<number | string, typeof actives[number]>();
    for (const item of actives) {
      const key = (item as any)?.collection_id ?? `${item.name}-${item.collection_date}`;
      map.set(key, item);
    }
    return Array.from(map.values());
  }, [actives]);

  return (
    <>
      {/* AKTYWNE */}
      {activeRows.length > 0 && (
        <InnerPageSection>
          <InnerPageTitle>
            <Text id="contributions:active" />
          </InnerPageTitle>

          <Table>
            <thead>
              <tr>
                <th><Text id="contribution:title" /></th>
                <th><Text id="contribution:price" /></th>
                <th><Text id="contribution:date" /></th>
                <th><Text id="contribution:expire" /></th>
              </tr>
            </thead>
            <tbody>
              {activeRows.map((row, idx) => (
                <tr
                  key={`${(row as any)?.collection_id ?? row.name}-${row.collection_date}-${idx}`}
                >
                  <td>{row.name ?? (row as any)?.type ?? '-'}</td>
                  <td><Money amount={row.value ?? 0} /></td>
                  <td>{row.collection_date ?? '-'}</td>
                  <td>{row.active_to ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <MembershipWidget />
        </InnerPageSection>
      )}

      {/* HISTORIA */}
      {history.length > 0 && (
        <InnerPageSection>
          <InnerPageTitle>
            <Text id="contributions:history" />
          </InnerPageTitle>

          <Table>
            <thead>
              <tr>
                <th><Text id="contribution:title" /></th>
                <th><Text id="contribution:price" /></th>
                <th><Text id="contribution:date" /></th>
                <th><Text id="contribution:expire" /></th>
              </tr>
            </thead>
            <tbody>
              {history.map((contribution, index) => (
                <tr
                  key={`${(contribution as any)?.collection_id ?? contribution.name}-${contribution.collection_date}-${index}`}
                >
                  <td>{contribution.name ?? (contribution as any)?.type ?? '-'}</td>
                  <td><Money amount={contribution.value ?? 0} /></td>
                  <td>{contribution.collection_date ?? '-'}</td>
                  <td>{contribution.active_to ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </InnerPageSection>
      )}
    </>
  );
};